import range from 'lodash/fp/range';
import { Fragment, type JSX, memo } from 'react';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';

import type { State } from '../../../reducers';
import type { TableColumn } from '../../enums/TableColumn';
import {
    getDrivingTimesChunkNumber,
    getSortBy,
    getSortDir,
    getTableViewMode,
} from '../../realtime/header/tablesettings/redux/tablesettings.redux';
import type { TableViewMode } from '../../realtime/header/tablesettings/redux/types';
import { realtimeActions } from '../../realtime/redux/realtime.redux';
import { chunkResult } from '../service/chunkService';
import { getCurrentColumns } from './columnService';
import { DrivingTimesTableRow } from './DrivingTimesTableRow';
import { getFilteredAndSortedDrivingTimesDisplayItems } from './drivingTimesDataPreparationService';
import type { DrivingTimesDisplayItem } from './types';

type TableBodyProps = TableBodyMapStateToProps & TableBodyMapDispatchToProps;

interface TableBodyMapDispatchToProps {
    onSelect: (id: string) => void;
}

interface TableBodyMapStateToProps {
    columns: TableColumn[];
    data: DrivingTimesDisplayItem[];
    tableViewMode: TableViewMode;
}

const TableBody = (props: TableBodyProps): JSX.Element => {
    const { columns, data, onSelect, tableViewMode } = props;

    // biome-ignore lint/correctness/noNestedComponentDefinitions: Only needed in block
    const TableCardPlaceholder = memo(() => {
        const content = range(0, 10).map(index => <tr key={index} className={'table-card-placeholder'} />);
        return <Fragment>{content}</Fragment>;
    });

    return (
        <tbody>
            {data.map((drivingTimeItem, index) => {
                const onRowSelected = (): void => {
                    onSelect(drivingTimeItem.id);
                };
                return (
                    <DrivingTimesTableRow
                        key={index}
                        columns={columns}
                        drivingTimesItem={drivingTimeItem}
                        onRowSelected={onRowSelected}
                        tableViewMode={tableViewMode}
                    />
                );
            })}
            <TableCardPlaceholder />
        </tbody>
    );
};

const mapStateToProps = (state: State): TableBodyMapStateToProps => ({
    columns: getCurrentColumns(state),
    data: chunkResult(
        getFilteredAndSortedDrivingTimesDisplayItems(state, getSortBy(state), getSortDir(state)),
        getDrivingTimesChunkNumber(state)
    ),
    tableViewMode: getTableViewMode(state),
});
const mapDispatchToProps = (dispatch: Dispatch): TableBodyMapDispatchToProps => ({
    onSelect: (id: string): void => {
        dispatch(realtimeActions.selectDrivingTimesTableRow(id));
    },
});

export const DrivingTimesTableBodyContainer = connect(mapStateToProps, mapDispatchToProps)(TableBody);
